import styled from 'styled-components';

export const ValueButton = styled.button`
    padding: 0;
    border: none;
    background: none;
    font: inherit;
    text-align: left;
`;
